export const BOOK_CREW_STATUS_TYPES = {
  CONFIRMED: 'Confirmed',
  DECLINED: 'Declined',
  MEMO_SENT: 'Memo Sent',
  MEMO_SAVED: 'Memo Saved'
};
